// @flow
import React from "react"
import { formatMoney } from "data/units/money/formatters"
import { getPricePerDayArray } from "data/units/money/helpers"
import type { DateRange } from "data/units/date/types"
import { sum } from "ramda"
import type { ProductVariantAvailableAffiliate } from "data/product/types"
import type { OriginalReservation } from "data/reservations/types"

type Props = {|
  variantAffiliate: ProductVariantAvailableAffiliate,
  dates: ?DateRange,
  originalReservation?: ?OriginalReservation,
|}

const Price = ({ variantAffiliate, dates, originalReservation }: Props) => {
  const price = getPricePerDayArray(
    dates,
    variantAffiliate,
    originalReservation,
  )
  const currency = variantAffiliate.location.country.currency

  return (
    <div>
      <div>
        {formatMoney(sum(price), false, currency)} {currency} total
      </div>
      <div>{price.length} days</div>
    </div>
  )
}

export default Price



// WEBPACK FOOTER //
// ./src/modals/ProductAvailability/Price/index.js